import postJson from './data/post.json';

const initialState = {
    post: postJson
}

const post = (state = initialState) => {
    return(state);
};

export default post;